import { render, staticRenderFns } from "./payment-type-giftcard.vue?vue&type=template&id=17a4ca5b&scoped=true&"
import script from "./payment-type-giftcard.vue?vue&type=script&lang=js&"
export * from "./payment-type-giftcard.vue?vue&type=script&lang=js&"
import style0 from "./payment-type-giftcard.vue?vue&type=style&index=0&id=17a4ca5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4ca5b",
  null
  
)

export default component.exports